import { Injectable } from '@angular/core';

import { Relationship } from '../../models/relationship';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class RelationshipService extends BackendBaseService {
  /**
   * Relationships resource base url
   * @type {string}
   */
  url: string = 'relationships';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  /**
   * Save a relationship
   * @param  {Relationship} relationship Relationship to save
   * @return {Promise<any>}              Server response
   */
  save(relationship: Relationship): Promise<any> {
    return super.save({
      relationship: relationship,
      id: relationship.id
    });
  }
}
